import React from "react";
import { Container } from "@mui/material";
import Footer from "./Footer";
import CookieConsentBanner from "./CookieConsentBanner";

function AuthLayout({ children }) {
    return (
        <Container component="main">
            <CookieConsentBanner />
            <div className="banner"></div>
            {children}
            <Footer />
        </Container>
    );
}

export default AuthLayout;
